import { Link, useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { useState } from "react";

const User: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("general");
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isNewFeeModalOpen, setIsNewFeeModalOpen] = useState(false);

  const [passwordErrors, setPasswordErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteConfirmed, setDeleteConfirmed] = useState(false);
  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false);
  const [isNewRoleModalOpen, setIsNewRoleModalOpen] = useState(false);
  const [newUserForm, setNewUserForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "enseignant",
    password: "",
    confirmPassword: "",
    isActive: true,
  });

  const [newRoleForm, setNewRoleForm] = useState({
    name: "",
    description: "",
    permissions: {
      dashboard: false,
      students: false,
      teachers: false,
      attendance: false,
      payments: false,
      communications: false,
      events: false,
      settings: false,
    },
  });

  const [newFeeForm, setNewFeeForm] = useState({
    name: "",
    description: "",
    defaultAmount: "",
    frequency: "monthly",
    isRequired: false,
  });

  const [newUserErrors, setNewUserErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const handleDelete = (item: any) => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
    setDeleteConfirmed(false);
  };
  const confirmDelete = () => {
    if (deleteConfirmed) {
      // Here you would typically make an API call to delete the item
      console.log("Deleting item:", itemToDelete);
      setIsDeleteModalOpen(false);
      setItemToDelete(null);
      setDeleteConfirmed(false);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Gestion des utilisateurs</h2>
      <p className={`mb-6 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
        Gérez les comptes utilisateurs et leurs accès
      </p>
      <div className="mb-6 flex justify-between items-center">
        <div className="relative w-64">
          <div
            className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
          >
            <i className="fas fa-search"></i>
          </div>
          <input
            type="text"
            placeholder="Rechercher un utilisateur..."
            className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
              isDarkMode
                ? "bg-[#161B22] border-gray-700"
                : "bg-white border-gray-300"
            } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />
        </div>
        <button
          id="newUserBtn"
          onClick={() => setIsNewUserModalOpen(true)}
          className={`flex items-center px-4 py-2 rounded-md ${
            isDarkMode
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-blue-500 hover:bg-blue-600"
          } text-white !rounded-button whitespace-nowrap`}
        >
          <i className="fas fa-user-plus mr-2"></i>
          <span>Nouvel utilisateur</span>
        </button>
        {isNewUserModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className={`${
                isDarkMode ? "bg-[#161B22]" : "bg-white"
              } rounded-lg p-6 w-full max-w-lg`}
            >
              <h3 className="text-xl font-semibold mb-4">
                Créer un nouvel utilisateur
              </h3>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Prénom
                    </label>
                    <input
                      type="text"
                      value={newUserForm.firstName}
                      onChange={(e) => {
                        setNewUserForm({
                          ...newUserForm,
                          firstName: e.target.value,
                        });
                        setNewUserErrors({
                          ...newUserErrors,
                          firstName: "",
                        });
                      }}
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700 text-white"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      placeholder="Prénom"
                    />
                    {newUserErrors.firstName && (
                      <p className="mt-1 text-sm text-red-500">
                        {newUserErrors.firstName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Nom
                    </label>
                    <input
                      type="text"
                      value={newUserForm.lastName}
                      onChange={(e) => {
                        setNewUserForm({
                          ...newUserForm,
                          lastName: e.target.value,
                        });
                        setNewUserErrors({
                          ...newUserErrors,
                          lastName: "",
                        });
                      }}
                      className={`w-full px-3 py-2 rounded-md border ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700 text-white"
                          : "bg-white border-gray-300"
                      } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      placeholder="Nom"
                    />
                    {newUserErrors.lastName && (
                      <p className="mt-1 text-sm text-red-500">
                        {newUserErrors.lastName}
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    value={newUserForm.email}
                    onChange={(e) => {
                      setNewUserForm({
                        ...newUserForm,
                        email: e.target.value,
                      });
                      setNewUserErrors({
                        ...newUserErrors,
                        email: "",
                      });
                    }}
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="email@example.com"
                  />
                  {newUserErrors.email && (
                    <p className="mt-1 text-sm text-red-500">
                      {newUserErrors.email}
                    </p>
                  )}
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Rôle
                  </label>
                  <select
                    value={newUserForm.role}
                    onChange={(e) =>
                      setNewUserForm({
                        ...newUserForm,
                        role: e.target.value,
                      })
                    }
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="administrateur">Administrateur</option>
                    <option value="enseignant">Enseignant</option>
                    <option value="parent">Parent</option>
                    <option value="comptable">Comptable</option>
                  </select>
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Mot de passe
                  </label>
                  <input
                    type="password"
                    value={newUserForm.password}
                    onChange={(e) => {
                      setNewUserForm({
                        ...newUserForm,
                        password: e.target.value,
                      });
                      setNewUserErrors({
                        ...newUserErrors,
                        password: "",
                      });
                    }}
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="••••••••"
                  />
                  {newUserErrors.password && (
                    <p className="mt-1 text-sm text-red-500">
                      {newUserErrors.password}
                    </p>
                  )}
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Confirmer le mot de passe
                  </label>
                  <input
                    type="password"
                    value={newUserForm.confirmPassword}
                    onChange={(e) => {
                      setNewUserForm({
                        ...newUserForm,
                        confirmPassword: e.target.value,
                      });
                      setNewUserErrors({
                        ...newUserErrors,
                        confirmPassword: "",
                      });
                    }}
                    className={`w-full px-3 py-2 rounded-md border ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700 text-white"
                        : "bg-white border-gray-300"
                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    placeholder="••••••••"
                  />
                  {newUserErrors.confirmPassword && (
                    <p className="mt-1 text-sm text-red-500">
                      {newUserErrors.confirmPassword}
                    </p>
                  )}
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isActive"
                    checked={newUserForm.isActive}
                    onChange={(e) =>
                      setNewUserForm({
                        ...newUserForm,
                        isActive: e.target.checked,
                      })
                    }
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor="isActive" className="ml-2 block text-sm">
                    Compte actif
                  </label>
                </div>
              </div>
              <div className="mt-6 flex justify-end space-x-3">
                <button
                  onClick={() => {
                    setIsNewUserModalOpen(false);
                    setNewUserForm({
                      firstName: "",
                      lastName: "",
                      email: "",
                      role: "enseignant",
                      password: "",
                      confirmPassword: "",
                      isActive: true,
                    });
                    setNewUserErrors({
                      firstName: "",
                      lastName: "",
                      email: "",
                      password: "",
                      confirmPassword: "",
                    });
                  }}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600"
                      : "bg-gray-200 hover:bg-gray-300"
                  } !rounded-button whitespace-nowrap`}
                >
                  Annuler
                </button>
                <button
                  onClick={() => {
                    // Here you would typically validate the form and make an API call
                    console.log("New user:", newUserForm);
                    setIsNewUserModalOpen(false);
                    setNewUserForm({
                      firstName: "",
                      lastName: "",
                      email: "",
                      role: "enseignant",
                      password: "",
                      confirmPassword: "",
                      isActive: true,
                    });
                  }}
                  className={`px-4 py-2 rounded-md ${
                    isDarkMode
                      ? "bg-blue-600 hover:bg-blue-700"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white !rounded-button whitespace-nowrap`}
                >
                  Créer l'utilisateur
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className={`rounded-lg overflow-hidden border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      >
        <table className="min-w-full divide-y divide-gray-700">
          <thead className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}>
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Nom
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Email
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Rôle
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
              >
                Statut
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody
            className={`${isDarkMode ? "bg-[#0D1117]" : "bg-white"} divide-y ${
              isDarkMode ? "divide-gray-700" : "divide-gray-200"
            }`}
          >
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-blue-600" : "bg-blue-500"
                    } text-white`}
                  >
                    <span>MD</span>
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Martin Dubois</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                martin.dubois@edugest.fr
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                  Administrateur
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                  Actif
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button
                    onClick={(e) => {
                      const button = e.target.closest("button");
                      if (!button) return;
                      const row = button.closest("tr");
                      if (!row) return;
                      // Get active tab to determine context
                      const activeTabElement = document.querySelector(
                        '[role="tab"][aria-selected="true"]'
                      );
                      const context =
                        activeTabElement?.getAttribute("data-tab") || activeTab;
                      let itemData: any = {};
                      // Extract data based on context
                      switch (context) {
                        case "users":
                          itemData = {
                            firstName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[0] || "",
                            lastName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[1] || "",
                            email:
                              row.querySelector("#userEmail")?.textContent ||
                              "",
                            role:
                              row
                                .querySelector("#userRole")
                                ?.textContent?.toLowerCase() || "",
                            isActive:
                              row
                                .querySelector("#userStatus")
                                ?.textContent?.includes("Actif") || false,
                          };
                          setNewUserForm(itemData);
                          setIsNewUserModalOpen(true);
                          break;
                        case "roles":
                          itemData = {
                            name:
                              row.querySelector("#roleName")?.textContent || "",
                            description:
                              row.querySelector("#roleDescription")
                                ?.textContent || "",
                            permissions: {
                              dashboard:
                                row.querySelector("#permDashboard")?.checked ||
                                false,
                              students:
                                row.querySelector("#permStudents")?.checked ||
                                false,
                              teachers:
                                row.querySelector("#permTeachers")?.checked ||
                                false,
                              attendance:
                                row.querySelector("#permAttendance")?.checked ||
                                false,
                              payments:
                                row.querySelector("#permPayments")?.checked ||
                                false,
                              communications:
                                row.querySelector("#permCommunications")
                                  ?.checked || false,
                              events:
                                row.querySelector("#permEvents")?.checked ||
                                false,
                              settings:
                                row.querySelector("#permSettings")?.checked ||
                                false,
                            },
                          };
                          setNewRoleForm(itemData);
                          setIsNewRoleModalOpen(true);
                          break;
                        case "payments":
                          itemData = {
                            name:
                              row.querySelector("#feeName")?.textContent || "",
                            description:
                              row.querySelector("#feeDescription")
                                ?.textContent || "",
                            defaultAmount:
                              row
                                .querySelector("#feeAmount")
                                ?.textContent?.replace(/[^0-9.]/g, "") || "",
                            frequency:
                              row
                                .querySelector("#feeFrequency")
                                ?.textContent?.toLowerCase() || "monthly",
                            isRequired:
                              row.querySelector("#feeRequired")?.checked ||
                              false,
                          };
                          setNewFeeForm(itemData);
                          setIsNewFeeModalOpen(true);
                          break;
                        default:
                          console.warn("Unknown context for edit operation");
                          return;
                      }
                      setSelectedItem(itemData);
                    }}
                    className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() =>
                      handleDelete({
                        id: "unique-id",
                        type: "user",
                      })
                    }
                    className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            onClick={confirmDelete}
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-green-600" : "bg-green-500"
                    } text-white`}
                  >
                    <span>SL</span>
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Sophie Laurent</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                sophie.laurent@edugest.fr
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">
                  Enseignant
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                  Actif
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button
                    onClick={(e) => {
                      const button = e.target.closest("button");
                      if (!button) return;
                      const row = button.closest("tr");
                      if (!row) return;
                      // Get active tab to determine context
                      const activeTabElement = document.querySelector(
                        '[role="tab"][aria-selected="true"]'
                      );
                      const context =
                        activeTabElement?.getAttribute("data-tab") || activeTab;
                      let itemData: any = {};
                      // Extract data based on context
                      switch (context) {
                        case "users":
                          itemData = {
                            firstName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[0] || "",
                            lastName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[1] || "",
                            email:
                              row.querySelector("#userEmail")?.textContent ||
                              "",
                            role:
                              row
                                .querySelector("#userRole")
                                ?.textContent?.toLowerCase() || "",
                            isActive:
                              row
                                .querySelector("#userStatus")
                                ?.textContent?.includes("Actif") || false,
                          };
                          setNewUserForm(itemData);
                          setIsNewUserModalOpen(true);
                          break;
                        case "roles":
                          itemData = {
                            name:
                              row.querySelector("#roleName")?.textContent || "",
                            description:
                              row.querySelector("#roleDescription")
                                ?.textContent || "",
                            permissions: {
                              dashboard:
                                row.querySelector("#permDashboard")?.checked ||
                                false,
                              students:
                                row.querySelector("#permStudents")?.checked ||
                                false,
                              teachers:
                                row.querySelector("#permTeachers")?.checked ||
                                false,
                              attendance:
                                row.querySelector("#permAttendance")?.checked ||
                                false,
                              payments:
                                row.querySelector("#permPayments")?.checked ||
                                false,
                              communications:
                                row.querySelector("#permCommunications")
                                  ?.checked || false,
                              events:
                                row.querySelector("#permEvents")?.checked ||
                                false,
                              settings:
                                row.querySelector("#permSettings")?.checked ||
                                false,
                            },
                          };
                          setNewRoleForm(itemData);
                          setIsNewRoleModalOpen(true);
                          break;
                        case "payments":
                          itemData = {
                            name:
                              row.querySelector("#feeName")?.textContent || "",
                            description:
                              row.querySelector("#feeDescription")
                                ?.textContent || "",
                            defaultAmount:
                              row
                                .querySelector("#feeAmount")
                                ?.textContent?.replace(/[^0-9.]/g, "") || "",
                            frequency:
                              row
                                .querySelector("#feeFrequency")
                                ?.textContent?.toLowerCase() || "monthly",
                            isRequired:
                              row.querySelector("#feeRequired")?.checked ||
                              false,
                          };
                          setNewFeeForm(itemData);
                          setIsNewFeeModalOpen(true);
                          break;
                        default:
                          console.warn("Unknown context for edit operation");
                          return;
                      }
                      setSelectedItem(itemData);
                    }}
                    className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() =>
                      handleDelete({
                        id: "unique-id",
                        type: "user",
                      })
                    }
                    className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            onClick={confirmDelete}
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-yellow-600" : "bg-yellow-500"
                    } text-white`}
                  >
                    <span>PB</span>
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Pierre Bertrand</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                pierre.bertrand@edugest.fr
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                  Parent
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                  Actif
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button
                    onClick={(e) => {
                      const button = e.target.closest("button");
                      if (!button) return;
                      const row = button.closest("tr");
                      if (!row) return;
                      // Get active tab to determine context
                      const activeTabElement = document.querySelector(
                        '[role="tab"][aria-selected="true"]'
                      );
                      const context =
                        activeTabElement?.getAttribute("data-tab") || activeTab;
                      let itemData: any = {};
                      // Extract data based on context
                      switch (context) {
                        case "users":
                          itemData = {
                            firstName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[0] || "",
                            lastName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[1] || "",
                            email:
                              row.querySelector("#userEmail")?.textContent ||
                              "",
                            role:
                              row
                                .querySelector("#userRole")
                                ?.textContent?.toLowerCase() || "",
                            isActive:
                              row
                                .querySelector("#userStatus")
                                ?.textContent?.includes("Actif") || false,
                          };
                          setNewUserForm(itemData);
                          setIsNewUserModalOpen(true);
                          break;
                        case "roles":
                          itemData = {
                            name:
                              row.querySelector("#roleName")?.textContent || "",
                            description:
                              row.querySelector("#roleDescription")
                                ?.textContent || "",
                            permissions: {
                              dashboard:
                                row.querySelector("#permDashboard")?.checked ||
                                false,
                              students:
                                row.querySelector("#permStudents")?.checked ||
                                false,
                              teachers:
                                row.querySelector("#permTeachers")?.checked ||
                                false,
                              attendance:
                                row.querySelector("#permAttendance")?.checked ||
                                false,
                              payments:
                                row.querySelector("#permPayments")?.checked ||
                                false,
                              communications:
                                row.querySelector("#permCommunications")
                                  ?.checked || false,
                              events:
                                row.querySelector("#permEvents")?.checked ||
                                false,
                              settings:
                                row.querySelector("#permSettings")?.checked ||
                                false,
                            },
                          };
                          setNewRoleForm(itemData);
                          setIsNewRoleModalOpen(true);
                          break;
                        case "payments":
                          itemData = {
                            name:
                              row.querySelector("#feeName")?.textContent || "",
                            description:
                              row.querySelector("#feeDescription")
                                ?.textContent || "",
                            defaultAmount:
                              row
                                .querySelector("#feeAmount")
                                ?.textContent?.replace(/[^0-9.]/g, "") || "",
                            frequency:
                              row
                                .querySelector("#feeFrequency")
                                ?.textContent?.toLowerCase() || "monthly",
                            isRequired:
                              row.querySelector("#feeRequired")?.checked ||
                              false,
                          };
                          setNewFeeForm(itemData);
                          setIsNewFeeModalOpen(true);
                          break;
                        default:
                          console.warn("Unknown context for edit operation");
                          return;
                      }
                      setSelectedItem(itemData);
                    }}
                    className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() =>
                      handleDelete({
                        id: "unique-id",
                        type: "user",
                      })
                    }
                    className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            onClick={confirmDelete}
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-red-600" : "bg-red-500"
                    } text-white`}
                  >
                    <span>CL</span>
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Claire Leroy</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                claire.leroy@edugest.fr
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800">
                  Comptable
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                  Inactif
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button
                    onClick={(e) => {
                      const button = e.target.closest("button");
                      if (!button) return;
                      const row = button.closest("tr");
                      if (!row) return;
                      // Get active tab to determine context
                      const activeTabElement = document.querySelector(
                        '[role="tab"][aria-selected="true"]'
                      );
                      const context =
                        activeTabElement?.getAttribute("data-tab") || activeTab;
                      let itemData: any = {};
                      // Extract data based on context
                      switch (context) {
                        case "users":
                          itemData = {
                            firstName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[0] || "",
                            lastName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[1] || "",
                            email:
                              row.querySelector("#userEmail")?.textContent ||
                              "",
                            role:
                              row
                                .querySelector("#userRole")
                                ?.textContent?.toLowerCase() || "",
                            isActive:
                              row
                                .querySelector("#userStatus")
                                ?.textContent?.includes("Actif") || false,
                          };
                          setNewUserForm(itemData);
                          setIsNewUserModalOpen(true);
                          break;
                        case "roles":
                          itemData = {
                            name:
                              row.querySelector("#roleName")?.textContent || "",
                            description:
                              row.querySelector("#roleDescription")
                                ?.textContent || "",
                            permissions: {
                              dashboard:
                                row.querySelector("#permDashboard")?.checked ||
                                false,
                              students:
                                row.querySelector("#permStudents")?.checked ||
                                false,
                              teachers:
                                row.querySelector("#permTeachers")?.checked ||
                                false,
                              attendance:
                                row.querySelector("#permAttendance")?.checked ||
                                false,
                              payments:
                                row.querySelector("#permPayments")?.checked ||
                                false,
                              communications:
                                row.querySelector("#permCommunications")
                                  ?.checked || false,
                              events:
                                row.querySelector("#permEvents")?.checked ||
                                false,
                              settings:
                                row.querySelector("#permSettings")?.checked ||
                                false,
                            },
                          };
                          setNewRoleForm(itemData);
                          setIsNewRoleModalOpen(true);
                          break;
                        case "payments":
                          itemData = {
                            name:
                              row.querySelector("#feeName")?.textContent || "",
                            description:
                              row.querySelector("#feeDescription")
                                ?.textContent || "",
                            defaultAmount:
                              row
                                .querySelector("#feeAmount")
                                ?.textContent?.replace(/[^0-9.]/g, "") || "",
                            frequency:
                              row
                                .querySelector("#feeFrequency")
                                ?.textContent?.toLowerCase() || "monthly",
                            isRequired:
                              row.querySelector("#feeRequired")?.checked ||
                              false,
                          };
                          setNewFeeForm(itemData);
                          setIsNewFeeModalOpen(true);
                          break;
                        default:
                          console.warn("Unknown context for edit operation");
                          return;
                      }
                      setSelectedItem(itemData);
                    }}
                    className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() =>
                      handleDelete({
                        id: "unique-id",
                        type: "user",
                      })
                    }
                    className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            onClick={confirmDelete}
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr
              className={`${
                isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
              }`}
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center ${
                      isDarkMode ? "bg-purple-600" : "bg-purple-500"
                    } text-white`}
                  >
                    <span>TM</span>
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Thomas Moreau</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                thomas.moreau@edugest.fr
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">
                  Enseignant
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                  Actif
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-center">
                <div className="flex justify-center space-x-3">
                  <button
                    onClick={(e) => {
                      const button = e.target.closest("button");
                      if (!button) return;
                      const row = button.closest("tr");
                      if (!row) return;
                      // Get active tab to determine context
                      const activeTabElement = document.querySelector(
                        '[role="tab"][aria-selected="true"]'
                      );
                      const context =
                        activeTabElement?.getAttribute("data-tab") || activeTab;
                      let itemData: any = {};
                      // Extract data based on context
                      switch (context) {
                        case "users":
                          itemData = {
                            firstName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[0] || "",
                            lastName:
                              row
                                .querySelector("#userName")
                                ?.textContent?.split(" ")[1] || "",
                            email:
                              row.querySelector("#userEmail")?.textContent ||
                              "",
                            role:
                              row
                                .querySelector("#userRole")
                                ?.textContent?.toLowerCase() || "",
                            isActive:
                              row
                                .querySelector("#userStatus")
                                ?.textContent?.includes("Actif") || false,
                          };
                          setNewUserForm(itemData);
                          setIsNewUserModalOpen(true);
                          break;
                        case "roles":
                          itemData = {
                            name:
                              row.querySelector("#roleName")?.textContent || "",
                            description:
                              row.querySelector("#roleDescription")
                                ?.textContent || "",
                            permissions: {
                              dashboard:
                                row.querySelector("#permDashboard")?.checked ||
                                false,
                              students:
                                row.querySelector("#permStudents")?.checked ||
                                false,
                              teachers:
                                row.querySelector("#permTeachers")?.checked ||
                                false,
                              attendance:
                                row.querySelector("#permAttendance")?.checked ||
                                false,
                              payments:
                                row.querySelector("#permPayments")?.checked ||
                                false,
                              communications:
                                row.querySelector("#permCommunications")
                                  ?.checked || false,
                              events:
                                row.querySelector("#permEvents")?.checked ||
                                false,
                              settings:
                                row.querySelector("#permSettings")?.checked ||
                                false,
                            },
                          };
                          setNewRoleForm(itemData);
                          setIsNewRoleModalOpen(true);
                          break;
                        case "payments":
                          itemData = {
                            name:
                              row.querySelector("#feeName")?.textContent || "",
                            description:
                              row.querySelector("#feeDescription")
                                ?.textContent || "",
                            defaultAmount:
                              row
                                .querySelector("#feeAmount")
                                ?.textContent?.replace(/[^0-9.]/g, "") || "",
                            frequency:
                              row
                                .querySelector("#feeFrequency")
                                ?.textContent?.toLowerCase() || "monthly",
                            isRequired:
                              row.querySelector("#feeRequired")?.checked ||
                              false,
                          };
                          setNewFeeForm(itemData);
                          setIsNewFeeModalOpen(true);
                          break;
                        default:
                          console.warn("Unknown context for edit operation");
                          return;
                      }
                      setSelectedItem(itemData);
                    }}
                    className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() =>
                      handleDelete({
                        id: "unique-id",
                        type: "user",
                      })
                    }
                    className="text-red-500 hover:text-red-700 cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                  {isDeleteModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                      <div
                        className={`${
                          isDarkMode ? "bg-[#161B22]" : "bg-white"
                        } rounded-lg p-6 w-full max-w-md`}
                      >
                        <div className="flex items-center mb-4">
                          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                            <i className="fas fa-exclamation-triangle text-red-500 text-xl"></i>
                          </div>
                          <h3 className="text-xl font-semibold ml-4">
                            Confirmer la suppression
                          </h3>
                        </div>
                        <p
                          className={`mb-6 ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Êtes-vous sûr de vouloir supprimer cet élément ? Cette
                          action est irréversible et toutes les données
                          associées seront définitivement perdues.
                        </p>
                        <div className="mb-4">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              checked={deleteConfirmed}
                              onChange={(e) =>
                                setDeleteConfirmed(e.target.checked)
                              }
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm">
                              Je comprends que cette action est irréversible
                            </span>
                          </label>
                        </div>
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setIsDeleteModalOpen(false);
                              setItemToDelete(null);
                              setDeleteConfirmed(false);
                            }}
                            className={`px-4 py-2 rounded-md ${
                              isDarkMode
                                ? "bg-gray-700 hover:bg-gray-600"
                                : "bg-gray-200 hover:bg-gray-300"
                            } !rounded-button whitespace-nowrap`}
                          >
                            Annuler
                          </button>
                          <button
                            onClick={confirmDelete}
                            disabled={!deleteConfirmed}
                            className={`px-4 py-2 rounded-md ${
                              deleteConfirmed
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-red-300 cursor-not-allowed"
                            } text-white !rounded-button whitespace-nowrap`}
                          >
                            Supprimer
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-6 flex justify-between items-center">
        <div
          className={`text-sm ${
            isDarkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Affichage de 1 à 5 sur 12 utilisateurs
        </div>
        <div className="flex space-x-2">
          <button
            className={`px-3 py-1 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap opacity-50 cursor-not-allowed`}
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            className={`px-3 py-1 rounded-md ${
              isDarkMode ? "bg-blue-600" : "bg-blue-500"
            } text-white !rounded-button whitespace-nowrap`}
          >
            1
          </button>
          <button
            className={`px-3 py-1 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
          >
            2
          </button>
          <button
            className={`px-3 py-1 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
          >
            3
          </button>
          <button
            className={`px-3 py-1 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default User;
